import { useState } from "react";

type CreatorAvatarProps = { src?: string; name: string; className?: string };

// Migrated Appwrite initials are generated placeholders, not uploaded photos.
// Render them locally so a retired/billing-blocked service cannot break avatars.
function isLegacyInitialsAvatar(src: string) {
  try {
    const url = new URL(src);
    return url.hostname.includes("appwrite") && /\/avatars\/initials\/?$/i.test(url.pathname);
  } catch {
    return false;
  }
}

export default function CreatorAvatar({ src = "", name, className = "" }: CreatorAvatarProps) {
  const [failedSource, setFailedSource] = useState<string | null>(null);
  const source = src.trim();
  const initials = name.trim().split(/\s+/).filter(Boolean).slice(0, 2).map((part) => Array.from(part)[0]).join("").toUpperCase() || "B";

  if (!source || isLegacyInitialsAvatar(source) || failedSource === source) {
    return (
      <span
        role="img"
        aria-label={name}
        className={`${className} inline-flex shrink-0 items-center justify-center bg-primary-500 text-white font-semibold`}
      >
        {initials}
      </span>
    );
  }

  return <img src={source} alt={name} className={className} onError={() => setFailedSource(source)} />;
}
